import TransactionSummary from "../../model/TransactionSummary";
import * as constant from '../../../shared/util/constant'
import { Column, Icon, Select } from "../../../components";
import '../MiddlePane/transactionSummary.scss'
import { Badge, Button, Dropdown, Overlay, Row, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FloatLabel } from "primereact/floatlabel";
import { checkEmptyString, preCommaString } from "../../../shared/util/stringManipulation";
import * as label from '../../../shared/util/label';
import PolicyMappingDataService, { getAgentCodeDisplay } from "../PolicyMappingDataService";
import { PolicyProcessStatus } from "../../model/PolicyProcessStatus";
import Logger from "../../../shared/services/Logger";
import ErrorPopup from "../../../shared/components/errorPopup";
import { useEffect, useRef, useState } from "react";
import { useConfirmationModalContext } from "../../../shared/components/ModalConfirmationContext";
import { toast } from "react-toastify";
import { formatDate } from '../../../shared/util/formatDate';
import { faCopy } from "@fortawesome/free-regular-svg-icons";
import moment from "moment";
import { CommonUtility } from "../../../Services/CommonUtility";

interface Props {
    transactionSummary: TransactionSummary;
    onStatusChange?: () => void;
}

const TransactionSummaryPanel = (props: Props) => {

    const IntialTransactionSummary: TransactionSummary = {
        policyNumber: "",
        insuredsName: "",
        streetAddressLine1: "",
        city: "",
        stateProvinceAbbreviation: "",
        zipCode: "",
        emailAddress:"",
        insuredsTelephoneNumber: "",
        cycleBusinessPurposeCode: "",
        transactionDate: "",
        transactionEffectiveDate: "",
        cycleBusinessPurpose: "",
        lineOfBusinessCode: "",
        currentTermAmount: null,
        companyCode: "",
        mgaCode: "",
        parentCompanyName:"",
        id: constant.DEFAULT_GUID
    }
    // Display modified values if available, otherwise show original values
    const streetAddressLine1 = checkEmptyString(props.transactionSummary.modifiedMailingAddress1 || props.transactionSummary.streetAddressLine1);
    const streetAddressLine2 = preCommaString(props.transactionSummary.modifiedMailingAddress2 || props.transactionSummary.streetAddressLine2);
    const addressLine3 = preCommaString(props.transactionSummary.addressLine3);
    const addressLine4 = preCommaString(props.transactionSummary.addressLine4)
    const stateProvinceAbbreviation = preCommaString(props.transactionSummary.modifiedMailingState || props.transactionSummary.stateProvinceAbbreviation)
    const zipCode = preCommaString(props.transactionSummary.modifiedMailingZip || props.transactionSummary.zipCode)
    const city = preCommaString(props.transactionSummary.modifiedMailingCity || props.transactionSummary.city)


    const propStreetAddressLine1 = checkEmptyString(props.transactionSummary.modifiedPropertyAddress1 || props.transactionSummary.propertyAddress1);
    const propStreetAddressLine2 = preCommaString(props.transactionSummary.modifiedPropertyAddress2 || props.transactionSummary.propertyAddress2);
    const propStateProvinceAbbreviation = preCommaString(props.transactionSummary.modifiedPropertyState || props.transactionSummary.propertyState)
    const propZipCode = preCommaString(props.transactionSummary.modifiedPropertyZip || props.transactionSummary.propertyZipCode)
    const propCity = preCommaString(props.transactionSummary.modifiedPropertyCity || props.transactionSummary.propertyCity)

    const [showErrorPopup, setshowErrorPopup] = useState(false);
    const [errorMessage, seterrorMessage] = useState("");
    const [isEditing, setIsEditing] = useState(false);
    const [updatedEffectiveDate, setUpdatedEffectiveDate] = useState<string | null>(null);
    const [updatedExpirationDate, setUpdatedExpirationDate] = useState<string | null>(null);
    const [updatedPremium, setUpdatedPremium] = useState<number | null>(null);
    const [updatedMailingAddress1, setUpdatedMailingAddress1] = useState<string>("");
    const [updatedMailingAddress2, setUpdatedMailingAddress2] = useState<string>("");
    const [updatedMailingCity, setUpdatedMailingCity] = useState<string>("");
    const [updatedMailingState, setUpdatedMailingState] = useState<string>("");
    const [updatedMailingZip, setUpdatedMailingZip] = useState<string>("");
    const [updatedPropertyAddress1, setUpdatedPropertyAddress1] = useState<string>("");
    const [updatedPropertyAddress2, setUpdatedPropertyAddress2] = useState<string>("");
    const [updatedPropertyCity, setUpdatedPropertyCity] = useState<string>("");
    const [updatedPropertyState, setUpdatedPropertyState] = useState<string>("");
    const [updatedPropertyZip, setUpdatedPropertyZip] = useState<string>("");
    const modalContext = useConfirmationModalContext();

    const [showCopyTooltip, setShowCopyTooltip] = useState(false);
    const [copyOverlayTarget, setCopyOverlayTarget] = useState(null);    
    const [usStates, setUsStates] = useState<{ value: string; label: string }[]>([]);

    const policyMappingDataService = new PolicyMappingDataService();



     const handleCopy = (e: React.MouseEvent, value: string) => {
        setCopyOverlayTarget(e.currentTarget);
        e.stopPropagation();
        navigator.clipboard.writeText(value);
        setShowCopyTooltip(true);
        setTimeout(() => {
          setShowCopyTooltip(false);
        }, 500);
      };

    const handleProcessStatusToggle = async () => {
        const currentStatus = props.transactionSummary.processStatus;
        const newStatus = currentStatus === 'H' ? 'M' : 'H';
        const policyProcessStatus: PolicyProcessStatus = {
            policyId: props.transactionSummary.id,
            policyStatus: newStatus
        };
        try {
            await policyMappingDataService.updateProcessStatus(policyProcessStatus);
            if (props.onStatusChange) props.onStatusChange();
        } catch (error) {
            Logger.logError(error.toString());
        }
    };

    const showErrorMessage = async () => {
        seterrorMessage(props.transactionSummary.processDetail);
        setshowErrorPopup(true);
    };

    const handleTransactionEdit = async () => {
        setIsEditing(true);
    }

    const handleCancel = () => {
        setUpdatedEffectiveDate(null);
        setUpdatedExpirationDate(null);
        setUpdatedPremium(null);
        setUpdatedMailingAddress1("");
        setUpdatedMailingAddress2("");
        setUpdatedMailingCity("");
        setUpdatedMailingState("");
        setUpdatedMailingZip("");
        setUpdatedPropertyAddress1("");
        setUpdatedPropertyAddress2("");
        setUpdatedPropertyCity("");
        setUpdatedPropertyState("");
        setUpdatedPropertyZip("");
        props.transactionSummary.modifiedEffectiveDate = null;
        props.transactionSummary.modifiedPremium = null;
        props.transactionSummary.modifiedExpirationDate = null;
        props.transactionSummary.modifiedMailingAddress1 = null;
        props.transactionSummary.modifiedMailingAddress2 = null;
        props.transactionSummary.modifiedMailingCity = null;
        props.transactionSummary.modifiedMailingState = null;
        props.transactionSummary.modifiedMailingZip = null;
        props.transactionSummary.modifiedPropertyAddress1 = null;
        props.transactionSummary.modifiedPropertyAddress2 = null;
        props.transactionSummary.modifiedPropertyCity = null;
        props.transactionSummary.modifiedPropertyState = null;
        props.transactionSummary.modifiedPropertyZip = null;
        setIsEditing(false);
    };

    const handleSave = () => {
        props.transactionSummary.modifiedEffectiveDate = updatedEffectiveDate;
        props.transactionSummary.modifiedPremium = updatedPremium;
        props.transactionSummary.modifiedExpirationDate = updatedExpirationDate;
        
        // Save mailing address fields only if modified
        props.transactionSummary.modifiedMailingAddress1 = updatedMailingAddress1 || null;
        props.transactionSummary.modifiedMailingAddress2 = updatedMailingAddress2 || null;
        props.transactionSummary.modifiedMailingCity = updatedMailingCity || null;
        props.transactionSummary.modifiedMailingState = updatedMailingState || null;
        props.transactionSummary.modifiedMailingZip = updatedMailingZip || null;
        
        // Save property address fields only if modified
        props.transactionSummary.modifiedPropertyAddress1 = updatedPropertyAddress1 || null;
        props.transactionSummary.modifiedPropertyAddress2 = updatedPropertyAddress2 || null;
        props.transactionSummary.modifiedPropertyCity = updatedPropertyCity || null;
        props.transactionSummary.modifiedPropertyState = updatedPropertyState || null;
        props.transactionSummary.modifiedPropertyZip = updatedPropertyZip || null;
        
        setIsEditing(false);
    };

    const handleDelete = async () => {

        const result = await modalContext.showConfirmation(label.UnmatchedPolicy.POLICY_TRANSACTION_DELETE)
        if (result) {
            const policyProcessStatus: PolicyProcessStatus = {
                policyId: props.transactionSummary.id,
                policyStatus: 'D'
            };
            try {
                await policyMappingDataService.updateProcessStatus(policyProcessStatus);
                if (props.onStatusChange) props.onStatusChange();
            } catch (error) {
                Logger.logError(error.toString());
                 
                toast.error(label.UnmatchedPolicy.POLICY_TRANSACTION_DELETE_ERROR, {
                    position: toast.POSITION.TOP_RIGHT
                });
            }
            setIsEditing(false);
        }
    };


    const fetchStates = async () => {
        const states = await policyMappingDataService.fetchUsStates();
        setUsStates(states);
    };

    useEffect(() => {
        fetchStates();
    }, []);

    useEffect(() => {
        handleCancel();
    }, [props.transactionSummary]);

    return (

        <>
            <div className="card">


                <div className="card-body card-body-height" style={{ minHeight: '400px' }}>
                    {
                        <>
                            <Row className={`pb-2 g-0 ${isEditing ? 'align-items-start' : ''}`}>
                                 <Overlay target={copyOverlayTarget} show={showCopyTooltip} placement="top">
                                  {(props) => (
                                    <Tooltip {...props}>
                                      Copied!
                                    </Tooltip>
                                  )}
                                </Overlay>
                                <Column lg={isEditing ? 6 : 9} className="middle-panel-header" style={{ paddingLeft: '0.9rem', paddingRight: 0 }}>
                                {isEditing ? (
                                    props.transactionSummary?.insuredsName?.split(' ').map((word, idx) => (
                                        <span key={idx} className="d-block">{word}</span>
                                    ))
                                ) : (
                                    props.transactionSummary?.insuredsName
                                )}
                               {props.transactionSummary?.insuredsName && <button
                                          className="copy-button"
                                          title="Copy to clipboard"
                                          onClick={(e)=>handleCopy(e,props.transactionSummary?.insuredsName)}
                                        >
                                          <FontAwesomeIcon size='lg' icon={faCopy} />
                                          
                                        </button>}
                                </Column>
                                <Column lg={isEditing ? 6 : 3} className="text-end p-0">
                                    {props.transactionSummary?.policyNumber && (
                                        isEditing ? (
                                            <>
                                                <Button
                                                    id="policy-actions-match"
                                                    variant="outline-primary"
                                                    className="btn-icon me-2"
                                                    onClick={handleCancel}
                                                >
                                                    {label.UnmatchedPolicy.CANCEL}
                                                </Button>
                                                <Button
                                                    id="policy-actions-match"
                                                    variant="primary"
                                                    className="btn-icon"
                                                    onClick={handleSave}
                                                >
                                                    {label.UnmatchedPolicy.SAVE}
                                                </Button>
                                            </>
                                        ) : (
                                            <Dropdown className="d-inline-block policy-actions-dropdown" align="end">
                                                <Dropdown.Toggle
                                                    variant="outline-secondary"
                                                    id="policy-header-actions-dropdown"
                                                    className="btn-icon three-dot-toggle"
                                                >
                                                    <i className="bi bi-three-dots"></i>
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item onClick={handleProcessStatusToggle}>
                                                        <i className="bi bi-pause me-2"></i>
                                                        {props.transactionSummary.processStatus === 'H' ? label.UnmatchedPolicy.REMOVEHOLD : label.UnmatchedPolicy.PALACEONHOLD}
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={handleTransactionEdit}>
                                                        <i className="bi bi-pencil me-2"></i>{label.UnmatchedPolicy.MODIFY}
                                                    </Dropdown.Item>
                                                    <Dropdown.Item onClick={handleDelete} className="text-danger">
                                                        <i className="bi bi-trash me-2"></i>{label.UnmatchedPolicy.DELETE}
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        )
                                    )}
                                </Column>
                                <Column lg={12} className="middle-panel-header" style={{ paddingLeft: '0.9rem', paddingRight: 0 }}>
                                    <span className="policy-number-cell">
                                        {"#" + props.transactionSummary?.policyNumber}
                                        {props.transactionSummary?.policyNumber && (
                                            <button
                                                className="copy-button"
                                                title="Copy to clipboard"
                                                onClick={(e) => handleCopy(e, props.transactionSummary?.policyNumber)}
                                            >
                                                <FontAwesomeIcon size='lg' icon={faCopy} />
                                            </button>
                                        )}
                                    </span>
                                </Column>
                            </Row>
                            <div className="transaction-type-box mb-3 d-flex flex-nowrap align-items-center justify-content-between">
                                <span className="middle-panel-text text-nowrap">
                                    <i className="pi pi-file" />
                                    &nbsp;
                                    {props.transactionSummary?.cycleBusinessPurpose || label.UnmatchedPolicy.POLICY_TRANSACTION}
                                </span>
                                <span className="d-flex align-items-center text-nowrap">
                                    <FontAwesomeIcon
                                        icon='check-circle'
                                        className="me-2"
                                    />
                                    {props.transactionSummary?.policyNumber && (
                                        <Button
                                            id="policy-actions-match"
                                            variant="outline-danger"
                                            className="btn-icon"
                                            onClick={showErrorMessage}
                                        >
                                            {props.transactionSummary?.processStatus === 'E' && <i className="bi bi-trash me-2"></i>}
                                            {props.transactionSummary?.processStatus === 'E' ? label.UnmatchedPolicy.SHOW_ERROR : label.UnmatchedPolicy.SHOW_REASON}
                                        </Button>
                                    )}
                                </span>
                            </div>
                            <div className="row">
                                <div className="overflow-auto col-lg-12 middle-panel">

                                    <Row className="address-row">                                        
                                        <Column lg={10} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.ADDRESS}
                                        </Column>
                                        {streetAddressLine1&&<Column lg={2} className="copy-icon-row">
                                         <button
                                                className="copy-button"
                                                title="Copy to clipboard"
                                                onClick={(e) => handleCopy(e,streetAddressLine1 + streetAddressLine2 + addressLine3 + addressLine4 + city + stateProvinceAbbreviation + zipCode)}
                                            >
                                                <FontAwesomeIcon size='lg' icon={faCopy} />
                                            </button>
                                        </Column>}
                                    </Row>
                                 
                                    {isEditing ? (
                                        <>
                                            <Row>
                                                <Column lg={12} className="middle-panel-label-text mt-n1">
                                                    <input
                                                        type="text"
                                                        className="form-control address-input mb-2"
                                                        placeholder="Address Line 1"
                                                        value={updatedMailingAddress1 || props.transactionSummary?.modifiedMailingAddress1 || props.transactionSummary?.streetAddressLine1 || ""}
                                                        onChange={(e) => setUpdatedMailingAddress1(e.target.value)}
                                                    />
                                                </Column>
                                            </Row>
                                            <Row>
                                                <Column lg={12} className="middle-panel-label-text">
                                                    <input
                                                        type="text"
                                                        className="form-control address-input mb-2"
                                                        placeholder="Address Line 2"
                                                        value={updatedMailingAddress2 || props.transactionSummary?.modifiedMailingAddress2 || props.transactionSummary?.streetAddressLine2 || ""}
                                                        onChange={(e) => setUpdatedMailingAddress2(e.target.value)}
                                                    />
                                                </Column>
                                            </Row>
                                            <Row className="g-1 city-state-zip-row">
                                                <Column lg={4}>
                                                    <input
                                                        type="text"
                                                        className="form-control address-input mb-2"
                                                        placeholder="City"
                                                        value={updatedMailingCity || props.transactionSummary?.modifiedMailingCity || props.transactionSummary?.city || ""}
                                                        onChange={(e) => setUpdatedMailingCity(e.target.value)}
                                                    />
                                                </Column>
                                                <Column lg={4}>
                                                    <Select
                                                        id="state"
                                                        controlId="state"
                                                        className='mb-3 address-input-select'
                                                        label={label.CustomerScreentLables.STATE}
                                                        options={usStates}
                                                        defaultSelected={usStates.filter(option =>
                                                            option.value === (updatedMailingState || props.transactionSummary?.modifiedMailingState || props.transactionSummary?.stateProvinceAbbreviation || "")
                                                        )}
                                                        onChange={(values) => setUpdatedMailingState(values[0] as string)}                                                       
                                                    />
                                                </Column>
                                                <Column lg={4}>
                                                    <input
                                                        type="text"
                                                        className="form-control address-input mb-2"
                                                        placeholder="Zip"
                                                        value={updatedMailingZip || props.transactionSummary?.modifiedMailingZip || props.transactionSummary?.zipCode || ""}
                                                        onChange={(e) => setUpdatedMailingZip(e.target.value)}
                                                    />
                                                </Column>
                                            </Row>
                                        </>
                                    ) : (
                                        <>
                                            <Row>
                                                <Column lg={12} className="middle-panel-label-text mt-n1">
                                                    <div className="address-value-box">
                                                        {streetAddressLine1 + streetAddressLine2 + addressLine3 + addressLine4}
                                                    </div>
                                                </Column>
                                            </Row>
                                            <Row>
                                                <Column lg={12} className="middle-panel-label-text">
                                                    {city.replace(/^,\s*/, '') + stateProvinceAbbreviation + zipCode}
                                                </Column>
                                            </Row>
                                        </>
                                    )}

                                    <Row>                                        
                                        <Column lg={10} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.EMAIL}
                                        </Column>
                                        {props.transactionSummary.emailAddress &&<Column lg={2} className="copy-icon-row">
                                         <button
                                                className="copy-button"
                                                title="Copy to clipboard"
                                                onClick={(e) => handleCopy(e, props.transactionSummary.emailAddress!)}
                                            >
                                                <FontAwesomeIcon size='lg' icon={faCopy} />
                                            </button>
                                        </Column>}
                                    </Row>

                                    <Row>                                        
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.emailAddress}
                                        </Column>
                                    </Row>
                                    {props.transactionSummary.lineOfBusinessCode === 'Homeowners' && (
                                        <>
                                            <Row className="address-row">
                                                <Column lg={10} className="middle-panel-label-header">
                                                    {label.UnmatchedPolicy.PROPERTY_ADDRESS}
                                                </Column>
                                                <Column lg={2} className="copy-icon-row">
                                         <button
                                                className="copy-button"
                                                title="Copy to clipboard"
                                                onClick={(e) => handleCopy(e,propStreetAddressLine1 + propStreetAddressLine2 + propCity + propStateProvinceAbbreviation + propZipCode)}
                                            >
                                                <FontAwesomeIcon size='lg' icon={faCopy} />
                                            </button>
                                        </Column>
                                            </Row>
                                            {isEditing ? (
                                                <>
                                                    <Row>
                                                        <Column lg={12} className="middle-panel-label-text mt-n1">
                                                            <input
                                                                type="text"
                                                                className="form-control address-input mb-2"
                                                                placeholder="Property Address Line 1"
                                                                value={updatedPropertyAddress1 || props.transactionSummary?.modifiedPropertyAddress1 || props.transactionSummary?.propertyAddress1 || ""}
                                                                onChange={(e) => setUpdatedPropertyAddress1(e.target.value)}
                                                            />
                                                        </Column>
                                                    </Row>
                                                    <Row>
                                                        <Column lg={12} className="middle-panel-label-text">
                                                            <input
                                                                type="text"
                                                                className="form-control address-input mb-2"
                                                                placeholder="Property Address Line 2"
                                                                value={updatedPropertyAddress2 || props.transactionSummary?.modifiedPropertyAddress2 || props.transactionSummary?.propertyAddress2 || ""}
                                                                onChange={(e) => setUpdatedPropertyAddress2(e.target.value)}
                                                            />
                                                        </Column>
                                                    </Row>
                                                    <Row className="g-1 city-state-zip-row">
                                                        <Column lg={4}>
                                                            <input
                                                                type="text"
                                                                className="form-control address-input mb-2"
                                                                placeholder="City"
                                                                value={updatedPropertyCity || props.transactionSummary?.modifiedPropertyCity || props.transactionSummary?.propertyCity || ""}
                                                                onChange={(e) => setUpdatedPropertyCity(e.target.value)}
                                                            />
                                                        </Column>
                                                        <Column lg={4}>
                                                            <Select
                                                                id="propstate"
                                                                controlId="propstate"
                                                                className='mb-3 address-input-select'
                                                                label={label.CustomerScreentLables.STATE}
                                                                options={usStates}
                                                                defaultSelected={usStates.filter(option =>
                                                                    option.value === (updatedPropertyState || props.transactionSummary?.modifiedPropertyState || props.transactionSummary?.propertyState || "")
                                                                )}
                                                                onChange={(values) => setUpdatedPropertyState(values[0] as string)}
                                                            />
                                                        </Column>
                                                        <Column lg={4}>
                                                            <input
                                                                type="text"
                                                                className="form-control address-input mb-2"
                                                                placeholder="Zip"
                                                                value={updatedPropertyZip || props.transactionSummary?.modifiedPropertyZip || props.transactionSummary?.propertyZipCode || ""}
                                                                onChange={(e) => setUpdatedPropertyZip(e.target.value)}
                                                            />
                                                        </Column>
                                                    </Row>
                                                </>
                                            ) : (
                                                <>
                                                    <Row>
                                                        <Column lg={12} className="middle-panel-label-text mt-n1">
                                                            <div className="address-value-box">
                                                                {propStreetAddressLine1 + propStreetAddressLine2}
                                                            </div>
                                                        </Column>
                                                    </Row>
                                                    <Row>
                                                        <Column lg={12} className="middle-panel-label-text">
                                                            {propCity.replace(/^,\s*/, '') + propStateProvinceAbbreviation + propZipCode}
                                                        </Column>
                                                    </Row>
                                                </>
                                            )}
                                        </>
                                    )}


                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.TRANSACTION}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.cycleBusinessPurposeCode}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.PARENT_COMPANY}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.parentCompanyName}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.ENTRY_DATE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.entryDate ? CommonUtility.formateDateStringtoDate(props.transactionSummary.entryDate): ""}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.CARRIER_TRANSACTION_DATE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                             {props.transactionSummary.transactionDate ?CommonUtility.formateDateStringtoDate(props.transactionSummary.transactionDate): ""}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.TRANSACTION_EFECTIVE_DATE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.transactionEffectiveDate ? 
                                              CommonUtility.formateDateStringtoDate(props.transactionSummary.transactionEffectiveDate): ""}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.EFFECTIVE_DATE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">

                                            {isEditing ? (
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={updatedEffectiveDate || props.transactionSummary?.modifiedEffectiveDate || props.transactionSummary?.policyEffectiveDate}
                                                    onChange={(e) => setUpdatedEffectiveDate(e.target.value)}
                                                />
                                            ) : (
                                                <span>
                                                    {props.transactionSummary.modifiedEffectiveDate ? 
                                                      CommonUtility.formateDateStringtoDate(props.transactionSummary.modifiedEffectiveDate) :
                                                      props.transactionSummary.policyEffectiveDate ? 
                                                         CommonUtility.formateDateStringtoDate(props.transactionSummary.policyEffectiveDate): ""}
                                                </span>
                                            )}
                                        </Column>
                                    </Row>

                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.EXPIRY_DATE}
                                        </Column>
                                    </Row>

                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {isEditing ? (
                                                <input
                                                    type="date"
                                                    className="form-control"
                                                    value={updatedExpirationDate || props.transactionSummary?.modifiedExpirationDate || props.transactionSummary?.policyExpirationDate}
                                                    onChange={(e) => setUpdatedExpirationDate(e.target.value)}
                                                />
                                            ) : (
                                                <span>
                                                    {props.transactionSummary.modifiedExpirationDate ? 
                                                      CommonUtility.formateDateStringtoDate(props.transactionSummary.modifiedExpirationDate) : 
                                                      props.transactionSummary.policyExpirationDate ? 
                                                         CommonUtility.formateDateStringtoDate(props.transactionSummary.policyExpirationDate) : ""}
                                                </span>
                                            )}
                                        </Column>
                                    </Row>

                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.PREMIUM}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {isEditing ? (
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    value={updatedPremium !== null ? updatedPremium : (props.transactionSummary?.modifiedPremium !== null && props.transactionSummary?.modifiedPremium !== undefined ? props.transactionSummary?.modifiedPremium : props.transactionSummary?.currentTermAmount)}
                                                    onChange={(e) => setUpdatedPremium(Number(e.target.value))}
                                                />
                                            ) : (
                                                <span>
                                                    {props.transactionSummary?.modifiedPremium !== null && props.transactionSummary?.modifiedPremium !== undefined
                                                        ? `$${props.transactionSummary?.modifiedPremium}`
                                                        : props.transactionSummary?.currentTermAmount === undefined
                                                            ? ""
                                                            : props.transactionSummary?.currentTermAmount === null
                                                                ? ""
                                                                : props.transactionSummary?.currentTermAmount === 0
                                                                    ? "$0"
                                                                    : "$" + props.transactionSummary?.currentTermAmount}
                                                </span>
                                            )}

                                        </Column>
                                    </Row>

                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.LINE_OF_BUSINESS}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.lineOfBusinessCode}
                                        </Column>
                                    </Row>

                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.COMPANY_CODE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.companyCode}
                                        </Column>
                                    </Row>

                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.MGA_CODE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.mgaCode}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.AGENT_NAME_CODE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {getAgentCodeDisplay(props.transactionSummary.contract_Number, props.transactionSummary.agencyName)}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-header">
                                            {label.UnmatchedPolicy.PRODUCER_SUB_CODE}
                                        </Column>
                                    </Row>
                                    <Row>
                                        <Column lg={12} className="middle-panel-label-text">
                                            {props.transactionSummary.producerSubCode}
                                        </Column>
                                    </Row>
                                </div>
                            </div>
                        </>}
                </div>
            </div>

            <ErrorPopup
                showErrorPopup={showErrorPopup}
                handleClose={() => { seterrorMessage(""); setshowErrorPopup(false) }}
                errorMessage={errorMessage}
                processDetail={props.transactionSummary}
            />
        </>
    )
}
export default TransactionSummaryPanel;